/* eslint-disable @typescript-eslint/no-explicit-any */
import request from 'utils/request';

const favoriteService = {
  getList: (params: any) => request.get('/favorite-catalog', { params }),
  getFavoriteCatalogItemsById: (id: any) =>
    request.get(`/favorite-catalog/${id}/items`),
  createFavoriteCatalog: (data: any) => request.post('/favorite-catalog', data),
  createFavoriteCatalogItems: (data: any) =>
    request.post('/favorite-catalog/items', data),
  deleteExpense: (id: any) => request.delete(`/favorite-catalog/${id}`),
  updateExpense: (id: any, data: any) =>
    request.put(`/favorite-catalog/${id}`, data)
};

export default favoriteService;
